
<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitCloseModal="close" v-if="showForm"></insertForm>

    <v-container>
      <v-card>
        <v-card-title>
          <h2>Report Parameter Master</h2>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:search="search"
          v-bind:pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ (props.index)+1 }}</td>
            <td class="text-xs-left">{{ props.item.parameter_name }}</td>
            <td class="text-xs-left">{{ props.item.parameter_title }}</td>
            <td class="text-xs-left">{{ props.item.parameter_type }}</td>
            <!-- <td class="text-xs-left">{{ props.item.table_name }}</td> -->
            <td class="text-xs-left">{{ props.item.column_ref_1 }}</td>
            <td class="text-xs-left">{{ props.item.column_ref_2 }}</td>
            <td class="text-xs-left">{{ (props.item.is_active == 1) ? "Yes" : "No" }}</td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" v-if="userRole.updateButton" @click="editItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.deleteButton"
                @click="deleteItem(props.index, props.item.id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import insertForm from "./parameter_master_form";

export default {
  components: {
    insertForm
  },

  data: () => ({
    showForm: false,
    dialog: false,
    totalItems: 0,
    loading: true,

    // DataTable data instance -------------
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "SL.",
        align: "left",
        sortable: false,
        value: "id"
      },
      {
        text: "Parameter Name",
        align: "left",
        sortable: false,
        value: "parameter_name"
      },
      {
        text: "Parameter Title",
        align: "left",
        value: "parameter_title"
      },
      {
        text: "Parameter Type",
        align: "left",
        value: "parameter_type"
      },
      /*{
        text: "Table Name",
        align: "left",
        value: "table_name"
      },*/
      {
        text: "Column Ref 1",
        align: "left",
        value: "column_ref_1"
      },
      {
        text: "Column Ref 2",
        align: "left",
        value: "column_ref_2"
      },
      {
        text: "Active",
        align: "left",
        value: "is_active"
      },
      {
        text: "Action",
        align: "left",
        value: ""
      }
    ],

    items: [],

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    },

    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: "",
      parameter_name: "",
      parameter_title: "",
      parameter_type: "",
      table_name: "",
      column_ref_1: "",
      column_ref_2: "",
      raw_sql_query:"", // add by bulbul
      is_active: 0
    }
  }),

  // User Previlization methods
  computed: {
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

  mounted() {
    this.loadData();
    // this.message = "Data loading!";
    // this.snackbar = true;
  },

  methods: {
    // Table data load request
    loadData(pagination) {
      commonService.getAllData("parameter_master").then(res => {
        this.showForm = this.userRole.saveButton;
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(data) {
      // Data edit form prepare
      this.showForm = true;

      this.formSchema = data;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      // data delete confirm modal
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "parameter_master").then(res => {
        this.items.splice(row_index, 1);
        this.close(res);
        this.confirmModel = false;
      });
    },

    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
      if (res.status == 1) {
        this.SnackbarVal.color = "success";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
        this.loadData();
      } else {
        this.SnackbarVal.color = "error";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/report/parameter_master/parameter_master_list.vue